module.exports = __webpack_public_path__ + "static/location-map-db39e9d7af0786fce4be048b09668485.png";